const nextInput = (event, scrollFunction) => {
    if (event?.key?.toLowerCase() === "enter") {
        const {form} = event.target
        const index = [...form].indexOf(event.target)
        form.elements[index + 1].focus()
        if (scrollFunction) {
            scrollFunction()
        }
        event.preventDefault();
    }
};

export default nextInput